<template>
  <div class="search">
    <input type="search" v-model="query" placeholder="Search" class="search__input" />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "search",

  data() {
    return {
      query: ""
    };
  },

  methods: {
    ...mapActions({
      search: "search/searchOffers"
    }),

    onSearch(e) {
      const {
        name,
        params: { query }
      } = this.$route;

      this.query = e.target;

      if (this.query) {
        this.search(this.query);
      }
    }
  },

  watch: {
    query(val) {
      this.search(this.query);
    }
  }
};
</script>

<style lang="sass" scoped>
.search
  position: relative
  bottom: 3px

  &__input
    height: 20px
    width: 150px
    margin: 0 0 0 10px
    background: $c-white
    color: $c-black
    text-indent: 5px
    font-size: 10px
    border-radius: 30px
    border: 1px solid darken($bg-color, 25%)
    padding-left: 20px
    background-image: url(../../assets/search.png)
    background-repeat: no-repeat
    background-size: 25px
    background-position-y: -3px
    transition: all .3s

    &:hover
      border: 1px solid $c-gray

    &::placeholder
      color: $c-mine-shaft
      font-size: 10px

    &:focus
      border: 1px solid $c-gray
      background: darken($bg-color, 15%)
      outline: none
</style>